import Axios from 'axios'
import store from '../store'

const device = {
  getClientId () {
    return store.getters['Client/clientId']
  },
  getDevicesByRoom (locationId, roomId) {
    return Axios.get(`api/internal/clients/` + this.getClientId() + '/locations/' + locationId + '/rooms/' + roomId + '/things')
  },
  saveDeviceByRoom (locationId, roomId, roomDevices) {
    return Axios.put(`api/internal/clients/` + this.getClientId() + '/locations/' + locationId + '/rooms/' + roomId + '/things', roomDevices)
  },
  getDevices () {
    return Axios.get('/api/internal/clients/' + this.getClientId() + '/things')
  },
  saveDevice (device) {
    return Axios.post('/api/internal/clients/' + this.getClientId() + '/things', device)
  },
  deleteDevice (id) {
    return Axios.delete('/api/internal/clients/' + this.getClientId() + '/things/' + id)
  }
}

export default device
